import axios from "axios";
import { API_URL } from "@/config";

const http = axios.create({ baseURL: API_URL, withCredentials: true });

export interface MarketplaceVehicle {
    vid: number;
    vyear: string | null;
    vmake: string | null;
    vmodel: string | null;
    vtrim: string | null;
    vvin: string | null;
    vcondition: string | null;
    vmileage: string | null;
    vecolor_txt: string | null;
    vbody: string | null;
    vrprice: string | null;
    vdprice: string | null;
    vspecialprice: string | null;
    vthubmnail_file: string | null;
    vthubmnail_file_path: string | null;
    vPhotoURLs: string | null;
    dealer: {
        id: number;
        company: string | null;
        city: string | null;
        state: string | null;
        phone: string | null;
        token: string;
    } | null;
}

export interface SearchVehiclesParams {
    make?: string;
    model?: string;
    year?: string;
    minPrice?: string;
    maxPrice?: string;
    condition?: string;
    page?: number;
    limit?: number;
}

export interface SearchVehiclesResult {
    vehicles: MarketplaceVehicle[];
    total: number;
    page: number;
    limit: number;
}

export async function searchVehicles(params: SearchVehiclesParams = {}): Promise<SearchVehiclesResult> {
    const q = new URLSearchParams();
    if (params.make) q.set("make", params.make);
    if (params.model) q.set("model", params.model);
    if (params.year) q.set("year", params.year);
    if (params.minPrice) q.set("minPrice", params.minPrice);
    if (params.maxPrice) q.set("maxPrice", params.maxPrice);
    if (params.condition) q.set("condition", params.condition);
    if (params.page) q.set("page", String(params.page));
    if (params.limit) q.set("limit", String(params.limit));
    const res = await http.get<SearchVehiclesResult>(`/marketplace/search?${q}`);
    return res.data;
}

export async function getMarketplaceMakes(): Promise<string[]> {
    const res = await http.get<string[]>("/marketplace/makes");
    return res.data;
}

export async function getMarketplaceModels(make: string): Promise<string[]> {
    const res = await http.get<string[]>(`/marketplace/${encodeURIComponent(make)}/models`);
    return res.data;
}

export async function getMarketplaceYears(): Promise<string[]> {
    const res = await http.get<string[]>("/marketplace/years");
    return res.data;
}
